
const newModel = () => {
    return {
        chuyenkhoaYId: null,
        ten: null,
        moTa: null,
        ghiChu: null,
        stt: null,
        enabled: null,
    }
}

const newFEModel = () => {
    return {
        chuyenkhoaYId: null,
        ten: null,
        moTa: null,
        ghiChu: null,
        stt: "0",
        enabled: true,
    }
}

const fromJson = (item) => {
    return {
        chuyenkhoaYId: item.chuyenkhoaYId,
        ten: item.ten,
        moTa: item.moTa,
        ghiChu: item.ghiChu,
        stt: item.stt,
        enabled: item.enabled,
    }
}

const parseModeltoFEModel = (item) => {
    return {
        chuyenkhoaYId: item.chuyenkhoaYId,
        ten: item.ten,
        moTa: item.moTa,
        ghiChu: item.ghiChu,
        stt: item.stt,
        enabled: item.enabled,
    }
}

const newPagingSearchModel = () => {
    return {
        pageNumber: null,
        pageSize: null,
        sort: null,
        chuyenkhoaYId: null,
        ten: null,
        enabled: null,
    }

}

const newSearchModel = (item) => {
    return {
        chuyenkhoaYId: item.chuyenkhoaYId,
        ten: item.ten,
        enabled: item.enabled,
    }
}

const errors = () => {
    return {
        chuyenkhoaYId: null,
        ten: null,
        moTa: null,
        ghiChu: null,
        stt: null,
        enabled: null,
    }
}

export const chuyenKhoaYModel = {
    newModel,
    newFEModel,
    parseModeltoFEModel,
    fromJson,
    newPagingSearchModel,
    newSearchModel,
    errors,
}


